<button type="button" (click)="generatePDF()" class="btn-custom btn btn-sm btn-outline-secondary"
        pTooltip="{{exportText}}" tooltipPosition="top" *ngIf="showAllButton || showPDF">
  <i class="fa fa-file-pdf"></i>Convert to PDF
</button>
